module.exports = __webpack_public_path__ + "img/reload-circle.d3b72690.svg";